import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { guid } from '@datorama/akita';
let TabIdService = class TabIdService {
    constructor() {
        this.tabKey = 'tabId';
    }
    getOrCreateTabId() {
        let tabId = sessionStorage.getItem(this.tabKey);
        if (!tabId) {
            tabId = this.generateTabId();
            sessionStorage.setItem(this.tabKey, tabId);
        }
        return tabId;
    }
    generateTabId() {
        return guid();
    }
    get tabId() {
        return sessionStorage.getItem(this.tabKey);
    }
};
TabIdService = __decorate([
    Injectable()
], TabIdService);
export { TabIdService };
